module.exports = __webpack_public_path__ + "img/pin-seven.52f61cad.svg";